import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FeedIcon from '@mui/icons-material/Feed';
import Chip from '@mui/material/Chip';
import React from 'react';
import { useQuery } from '../hooks/useQuery';

const ItemContrato = ({ item, onClick, index }) => {
  const [isDownloadingPdf, setIsDownloadingPdf] = React.useState(false);
  const { detalheContrato } = useQuery();

  async function downloadPdf(path, filename) {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.setAttribute('target', '_blank');
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  const downloadContrato = async (contrato) => {
    try {
      setIsDownloadingPdf(true);
      const result = await detalheContrato(contrato);
      if (!result.data.data[0].contrato_pdf) {
        alert('PDF não encontrado');
        return;
      }
      downloadPdf(result.data.data[0].contrato_pdf, 'contrato.pdf');
    } catch (error) {
      console.log(error);
    } finally {
      setIsDownloadingPdf(false);
    }
  };

  const handleCutString = (str) => {
    if (!str) return '';
    return str.length > 100 ? `${str.substring(0, 100)}...` : str;
  };

  return (
    <tr style={{}}>
      <td colSpan={6}>
        <Accordion style={{ padding: 0, boxShadow: 'none', margin: 0 }}>
          <AccordionSummary
            style={{
              padding: 0,
              margin: 0,
              height: '5rem',
              borderBottom: '1px solid #e2e9ee',
              background: index % 2 === 1 ? 'white' : '#f0eded',
            }}
            expandIcon={<ExpandMoreIcon style={{ marginRight: '1rem' }} />}
            aria-controls={'panel-content' + item.contrato}
            id={'panel-header' + item.contrato}
          >
            <table
              style={{
                width: '100%',
                margin: 0,
              }}
            >
              <tbody>
                <tr style={{}}>
                  <td
                    style={{
                      color: '#0e72b8',
                      width: '15.2%',
                      padding: '1rem',
                    }}
                  >
                    {item.contrato}
                  </td>
                  <td
                    style={{ width: '17.98%', padding: '1rem', fontSize: '' }}
                  >
                    <p className="w-100 ellipsin">
                      {handleCutString(item.objeto)}
                    </p>
                  </td>
                  <td
                    style={{ width: '20%', padding: '1rem', fontSize: '1rem' }}
                  >
                    {item.nom_consultor}
                  </td>
                  <td
                    style={{
                      width: '12.66%',
                      padding: '1rem',
                      fontSize: '1rem',
                    }}
                  >
                    {item.fim}
                  </td>
                  <td
                    style={{ width: '8%', padding: '1rem', fontSize: '1rem' }}
                  >
                    <Chip label="Contrato" color="primary" />
                  </td>
                  <td style={{ width: '24%', fontSize: '1rem' }}>
                    <div className="actions">
                      <Button
                        variant="contained"
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadContrato(item.contrato_dts);
                        }}
                        disabled={isDownloadingPdf}
                        style={{ marginRight: 2 }}
                      >
                        {isDownloadingPdf ? (
                          <CircularProgress size={24} />
                        ) : (
                          <SaveAltIcon sx={{ fontSize: 24 }} />
                        )}
                      </Button>
                      <Button
                        variant="contained"
                        style={{ marginRight: 4 }}
                        onClick={onClick}
                      >
                        <FeedIcon sx={{ fontSize: 24, marginRight: 1 }} />
                        Notas Fiscais
                      </Button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </AccordionSummary>
          <AccordionDetails>
            <p style={{ color: '#0e72b8' }}>Objeto</p>
            <p style={{ color: '#919191' }}>{item.objeto}</p>
            <p style={{ color: '#0e72b8' }}>Vigência</p>
            <p style={{ color: '#919191' }}>{item.fim}</p>
            <p style={{ color: '#0e72b8' }}>Itens do contrato</p>
            {item &&
              item.item &&
              item.item.map((item, i) => {
                return (
                  <p style={{ color: '#919191' }} key={`item${i}`}>
                    {item.item}
                    {' - '}
                    {item.descricao}
                  </p>
                );
              })}
          </AccordionDetails>
        </Accordion>
      </td>
    </tr>
  );
};

export default ItemContrato;
